import Vue from 'vue/dist/vue.esm'

Vue.component(
  'custom-form-vue',
  () => import(/* webpackChunkName: "[request]" */ "components/forms/CustomForm")
)
